import { Middleware } from 'redux';
import { RaygunBreadCrumbMetaData, addBreadcrumb, mapDraftToRaygunDraft } from '@/utils/raygun';
import { DraftActionTypes } from '@/redux/draft/types';
import { StoreDispatch, StoreState } from '../types';

export const reduxActionLogMiddleware = (): Middleware<any, StoreState, StoreDispatch> => {
  return () => (next) => (action) => {
    const nextAction = next(action);

    const metaData: RaygunBreadCrumbMetaData = { action: action.type };
    if (action.type === DraftActionTypes.SET_DRAFT) {
      metaData.draft = mapDraftToRaygunDraft(action.draft);
    }

    addBreadcrumb(`Executing redux action '${action.type}'`, metaData);

    return nextAction;
  };
};
